module.exports = __webpack_public_path__ + "img/icon_ct_close.0c856728.svg";